// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Google Sans";
  src: url('GoogleSans-Regular.woff2') format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Google Sans";
  src: url('GoogleSans-Medium.woff2') format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Google Sans";
  src: url('GoogleSans-Bold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
*,
body,
html,
p,
span,
h1,
h2,
h3,
h4,
h5,
h6,
strong,
li {
  --ion-font-family: "Google Sans";
  font-family: "Google Sans";
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACC,0BAAA;EACA,oDAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AACD;AAEA;EACC,0BAAA;EACA,mDAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAAD;AAGA;EACC,0BAAA;EACA,iDAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AADD;AAMA;;;;;;;;;;;;;EAaC,gCAAA;EACA,0BAAA;AAJD","sourcesContent":["@font-face {\n\tfont-family: 'Google Sans';\n\tsrc: url('../assets/font/GoogleSans-Regular.woff2') format('woff2');\n\tfont-weight: 400;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n\n@font-face {\n\tfont-family: 'Google Sans';\n\tsrc: url('../assets/font/GoogleSans-Medium.woff2') format('woff2');\n\tfont-weight: 500;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n\n@font-face {\n\tfont-family: 'Google Sans';\n\tsrc: url('../assets/font/GoogleSans-Bold.woff2') format('woff2');\n\tfont-weight: bold;\n\tfont-style: normal;\n\tfont-display: swap;\n}\n\n\n\n*,\nbody,\nhtml,\np,\nspan,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nstrong,\nli {\n\t--ion-font-family: 'Google Sans';\n\tfont-family: 'Google Sans';\n\t//letter-spacing: .05rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
